


















import Vue from 'vue'
import {
  availableTypeOptions,
  availableSizeOptions,
} from '@/types/button-style-options'

export default Vue.extend({
  name: 'DdButton',

  props: {
    type: {
      type: String,
      default: 'default',
      validator: (value: string) => {
        return availableTypeOptions.includes(value)
      },
    },

    color: {
      type: String,
      default: 'grey',
    },

    size: {
      type: String,
      default: 'large',
      validator: (value: string) => {
        return availableSizeOptions.includes(value)
      },
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },

    isAutofocus: {
      type: Boolean,
      default: false,
    },

    isLoading: {
      type: Boolean,
      default: false,
    },

    newIcon: {
      type: Boolean,
      default: false,
    },

    fullWidth: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    disabledState(): boolean {
      return this.isDisabled || this.isLoading
    },

    modifiers(): Array<String> {
      const baseSelector = 'dd-button--'

      // Colors
      const selectors = [
        baseSelector + this.size,
        baseSelector + this.type,
        baseSelector + this.color,
      ]

      // Loading
      if (this.isLoading) {
        selectors.push('dd-button--loading')
        selectors.push('dd-button--disabled')
      }

      if (this.isDisabled) {
        selectors.push('dd-button--disabled')
      }

      if (this.fullWidth) {
        selectors.push('dd-button__full-width')
      }

      return selectors
    },
  },
})
